module.exports = __webpack_public_path__ + "img/logo-4.8ef4faaa.svg";